import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DroitsService } from '../../../../services/droits.service';
import { AppService } from '../../../../services/app.service';
import { of } from 'rxjs';
import { StateService } from '../../../../services/state.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'kt-choice-courrier',
  templateUrl: './choice-courrier.component.html',
  styleUrls: ['./choice-courrier.component.scss']
})
export class ChoiceCourrierComponent implements OnInit {
  droits: any = [];
  courriers: any[];
  rights: any[] = [];
  typeCourrier: any[];
  selectedCourrier: any;
  destinataire: any = {};
  libres: any = []; 
  
  search: any;
  typeCourriersFilters: any[];
  
  constructor(
    public dialogRef: MatDialogRef<ChoiceCourrierComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private changeDetectorRef : ChangeDetectorRef,
    public droitsService: DroitsService,
    private stateService : StateService
  ) { }

  ngOnInit() {
    this.droits = this.data.droits;
    if (this.data.rights!=undefined)
    	this.rights=this.data.rights;
    
    this.stateService.dossier.pipe(first()).subscribe((dossier) => {
      if(this.data.courrier && this.data.courrier.destination)
          this.destinataire = this.data.courrier.destination.ID;
      else
          this.destinataire = dossier.ID;
    })
    
    console.log("ChoiceCourrierComponent",this.data);
    this.appService.getParamsDemandeCourrier(this.data.demande.type.ID).subscribe((result) => {
      this.typeCourrier = [];
	  this.typeCourriersFilters=[];
      result.result.forEach((cour) => {
		  
		  
		  
		  cour.readAndAdd=true;
		  
		  if ( cour.key !=undefined 
		  && cour.key
			  && this.rights!=undefined
			  && this.rights[cour.key]!=undefined
			  && this.rights[cour.key].w!=undefined	
			  )
			  	cour.readAndAdd=this.rights[cour.key].w;
		  
		  if (
			cour.readAndAdd  
		  && cour.key !=undefined 
		  && cour.key
		  && this.droits!=undefined
		  && this.droits[cour.key]!=undefined
		  && this.droits[cour.key].c!=undefined	
		  )
		  cour.readAndAdd=this.droits[cour.key].c;
		  
		  
		  
		  
         /* if(cour.types[this.data.demande.type.ID])*/
              this.typeCourrier.push(cour);
      });
	  this.typeCourriersFilters=[...this.typeCourrier];
      console.log("ChoiceCourrierComponent",this.typeCourrier);
      this.changeDetectorRef.detectChanges();
  });
    this.libres = [
      {
          "key":"CHAMP_LIBRE0",
          "value": ''
      },
      {
          "key":"CHAMP_LIBRE1",
          "value": ''
      },
      {
          "key":"CHAMP_LIBRE2",
          "value":''
      }
    ]
  }

  setSelectedCourrier(){
    console.log(this.typeCourrier);
    this.selectedCourrier = false;
    this.typeCourrier.forEach((cour) => {
      if(cour.selected)
        this.selectedCourrier = true;
    })
  }
  
  save() {
    let courriers = [];
    this.typeCourrier.forEach((cour) => {
      if(cour.selected)
        courriers.push(cour.key);
    });
	this.selectedCourrier = false;
    this.appService.generateCourriers(courriers, this.data.instruction.ID).subscribe((courriers) => {
      if(courriers.result){
          this.dialogRef.close(courriers.result);
      }
      else
          of(window.confirm("Le type de courrier demandé n'est pas présent, problème de configuration"));
       this.selectedCourrier = true;
    })
    /*this.appService.getHtmlCourrier(this.selectedCourrier, this.data.demande, this.libres, this.destinataire).subscribe((courrier) => {  
      this.selectedCourrier.html = courrier.result.html; 
      this.appService.getCourrier(this.selectedCourrier, this.data.instruction.demande, 'HTML2PDF', '', this.libres, this.destinataire).then((courrier) => {         
        if(courrier.result[0].value){
          this.dialogRef.close(courrier.result[0].value);
        }
        else
            of(window.confirm("Le type de courrier demandé n'est pas présent, problème de configuration"));
      });
    });*/
	}
	
	filterResults() {
		    if (!this.search) {
		      this.typeCourriersFilters = [...this.typeCourrier];
		    } else {
		      this.typeCourriersFilters = [];
		      this.typeCourriersFilters = this.typeCourrier.filter((courrier) => {
		        return courrier.libelle.toUpperCase().indexOf(this.search.toUpperCase()) > -1;
		      });
		    }
	}
	 
	
}
